"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TimeUtils =
/*#__PURE__*/
function () {
  function TimeUtils() {
    _classCallCheck(this, TimeUtils);
  }

  _createClass(TimeUtils, null, [{
    key: "getTimestamp",
    value: function getTimestamp() {
      return Date.now();
    }
  }, {
    key: "getUTCISOTime",
    value: function getUTCISOTime() {
      return new Date().toISOString();
    }
  }]);

  return TimeUtils;
}();

exports.TimeUtils = TimeUtils;